import superMeta from '../_DES_CAT/metaDesCatNode.mjs'

export default {
    ...superMeta,
    name: '变更内容',
    type: 'CHG_CHG',
}
